;(function() {
"use strict";

angular.module('core.assert', [])
  .service('assert', assertService);

function assertService() {
  return function (condition, message) {
    const error = new Error(`AssertionError: ${message}`);
    error.name = 'AssertionError';
    if (!condition) throw error;
  };
}
}());
